import { useEffect, useMemo, useState } from 'react';
import { groupTripApi } from '../../api/groupTripApi';
import { useAuth } from '../../auth/AuthContext';
import { opaqueId } from './groupTripModel';
import { indexById } from './disruptionModel';

/**
 * 處理協議頁面的顯示資料：訂位、旅伴名冊、Host 與目前登入者。
 * 任一來源讀取失敗都只退回一般稱呼，不影響協議本身的顯示；這些資料只用於顯示與介面便利，不作為授權依據。
 */
export function useSettlementDisplayContext(groupTripId) {
  const { user } = useAuth();
  const viewerId = opaqueId(user?.memberId ?? user?.id);
  const [context, setContext] = useState({ bookings: [], travelers: [], hostMemberId: null });

  useEffect(() => {
    let active = true;
    Promise.allSettled([
      groupTripApi.listBookings(groupTripId),
      groupTripApi.listTravelers(groupTripId),
      groupTripApi.get(groupTripId),
    ]).then(([bookingResult, travelerResult, tripResult]) => {
      if (!active) return;
      const itemsOf = (result) => (result.status === 'fulfilled' && Array.isArray(result.value?.items) ? result.value.items : []);
      setContext({
        bookings: itemsOf(bookingResult),
        travelers: itemsOf(travelerResult),
        hostMemberId: tripResult.status === 'fulfilled' ? opaqueId(tripResult.value?.hostMemberId) : null,
      });
    });
    return () => { active = false; };
  }, [groupTripId]);

  const bookingsById = useMemo(() => indexById(context.bookings, 'bookingId'), [context.bookings]);
  const travelersById = useMemo(() => indexById(context.travelers, 'travelerId'), [context.travelers]);
  return { ...context, bookingsById, travelersById, viewerId };
}
